'use strict';

var courses = angular.module('gymsystem.courses', []);

courses.factory('courseutil', ['$rootScope', '$modal', 'server', 'util', 'formatter', function($rootScope, $modal, server, util, formatter) {
    var courseutil = {};

    courseutil.transformCourse = function(c) {
        c.startTime = Date.newFull(c.startTime);
        c.endTime = Date.newFull(c.endTime);
        c.firstBookingTime = Date.newFull(c.firstBookingTime);
        c.lastBookingTime = Date.newFull(c.lastBookingTime);
        c.product = $rootScope.getPointerById(c.product_id, $rootScope.trainingcardtypes);
        c.category = $rootScope.getPointerById(c.category_id, $rootScope.coursecategories);
        c.name = c.product ? c.product.name : null;
        (c.bookings || []).forEach(function(b) {
            if (b.user_id) {
                b.user = $rootScope.getMember(b.user_id);
            }
            if (b.booker_id) {
                b.booker = $rootScope.getMember(b.booker_id);
            }
        });
        if(c.paybackTraningcard_id != null) {
            c.paybackTraningcardsBool = true;
            c.paybackTraningcard = $rootScope.getPointerById(c.paybackTraningcard_id, $rootScope.trainingcardtypes);
        }
        if (c.tags) {
            c.tags = _.map(c.tags, function(id) {
                return (_.isObject(id) && id.id) ? id : _.findWhere($rootScope.systemtags, { id: id });
            });
        }
        return c;
    };

    courseutil.show = function(course_or_course_id) {
        var doShow = function(course) {
            $modal.open({
                templateUrl: 'views/course.html',
                windowClass: 'large-modal-window',
                controller: 'CourseCtrl',
                resolve: {
                    course: function() {
                        return course;
                    }
                }
            });
        };

        server.get('/api/course/get', {id: angular.isObject(course_or_course_id) ? course_or_course_id.id : course_or_course_id}).then(function(data) {
            doShow(courseutil.transformCourse(data));
        });
    };

    courseutil.change = function(course_or_course_id) {
        server.get('/api/course/get', {id: angular.isObject(course_or_course_id) ? course_or_course_id.id : course_or_course_id}).then(data => {
            util.showDataDialog({
                controller: 'CourseDataCtrl',
                item: courseutil.transformCourse(data),
                windowClass: 'large-modal-window'
            });
        });
    };

    courseutil.getCancelPolicyListHtml = function(rules) {
        var html = '';
        if (rules && rules.length) {
            html += '<div>' + util.t('CANCEL_COURSE_RULE_HINT') + '</div>';
        }

        (rules || []).forEach(function(rule) {
            var timeunitName = util.t(_.findWhere(util.timeunits, {id: rule.time.timeunit}).name).toLowerCase();
            var relativeName = util.t(_.findWhere(util.relative, {id: rule.time.relative}).name).toLowerCase();
            var cost = '';
            if (rule.cost_percent) {
                cost += rule.cost_percent + ' % ' + util.t('of the course price');
            }
            if (rule.cost_fixed) {
                if (cost) {
                    cost += ' + ';
                }
                cost += formatter.format('price', rule.cost_fixed);
            } else {
                if (!cost) {
                    cost = formatter.format('price', 0);
                }
            }

            html += '<div>' + util.t(rule.time.relative == 'beforestart' ? 'Is it less than' : 'Is it more than') + ' ' + rule.time.value + ' ' + timeunitName + ' ' + relativeName + ' ' + util.t('cancellation is allowed') + ' ' + util.t('for') + ' ' + cost + '</div>';
        });
        return html;
    };

    courseutil.getLastCancelTime = function(course, lastCancelTime) {
        var hours = util.getHoursFromRelativeTime(lastCancelTime.value, lastCancelTime.timeunit);
        var ms = hours*60*60*1000;
        var d = course.startTime.clone();
        if (lastCancelTime.relative == 'beforestart') {
            d.setTime(d.getTime() - ms);
        } else if (lastCancelTime.relative == 'afterstart') {
            d.setTime(d.getTime() + ms);
        }

        return d;
    };

    return courseutil;
}]);

courses.controller('CourseListCtrl', ['$rootScope', '$scope', 'live', '$timeout', '$filter', '$modal', 'formatter', 'courseutil', 'server', 'confirm', '$q', 'util', function($rootScope, $scope, live, $timeout, $filter, $modal, formatter, courseutil, server, confirm, $q, util) {
    $scope.add = function() {
        var tab = $scope.config.control.getActiveTab();
        var category = tab && tab.context;

        util.showDataDialog({controller: 'CourseDataCtrl', initial: {category_id: category && category.id}, windowClass: 'large-modal-window'});
    };

    function fetchCourse(course_id) {
        return $q.promise(function(resolve, reject) {
            server.get('/api/course/get', {id: course_id}).then(function(data) {
                resolve(courseutil.transformCourse(data));
            }, reject); 
        });
    }

    $scope.change = function(course) {
        courseutil.change(course);
    };

    $scope.copy = function(course) {
        fetchCourse(course.id).then(function(course) {
            util.showDataDialog({controller: 'CourseDataCtrl', initial: course, windowClass: 'large-modal-window', copy: true}).result.then(function(newCourse) {
                $modal.open({
                    templateUrl: 'views/addmodal.html',
                    controller: 'CourseCopyCtrl',
                    resolve: {
                        course: function() {
                            return course;
                        },
                        newCourse: function() {
                            return newCourse;
                        }
                    }
                });
            });
        });
    };

    $scope.remove = function(course) {
        confirm.show('Are you sure you want to remove the course?', {ladda: true}).then(function(resolve) {
            server.post('/api/course/remove', null, {id: course.id}, 'Course removed', 'Failed to remove course').then(resolve);
        });
    };

    $scope.showCourse = function(course) {
        courseutil.show(course);
    };

    function buildTabs() {
        var categories = $filter('orderBy')($rootScope.coursecategories.filter(function(c) { return c.active && c.sites.indexOf($rootScope.selectedSite.id) != -1; }), 'order');
        var empty = { title: 'You currently have no active courses in this category', button: { title: 'Add course', onClick: $scope.add } };
        var tabs = categories.map(function(c) {
            return { name: c.name, badgeClass: 'badge-success', itemFilter: function(course) { return course.category_id == c.id && !course.endTime.isPastDate(); }, context: c, empty: empty };
        });
        var historyOnEmpty = {
            getTitle: function() {
                var tab = $scope.config.control.getActiveTab();
                return (!tab || tab.config.control.getNumberOfItems() == 0) ? 'Your completed courses will be gathered here' : 'This is where your completed courses are gathered';
            },
            getText: function() {
                var tab = $scope.config.control.getActiveTab();
                if (!tab || tab.config.control.getNumberOfItems() == 0) { return ''; }
                return 'Do you want to give one of the courses again? Click on "Copy" to use a completed course as a template.';
            },
            visible: function() { return true; }
        };
        tabs.push(
            {name: 'History', itemFilter: function(course) { return course.endTime.isPastDate(); }, empty: historyOnEmpty }
        );
        return tabs;
    }

    function getTimePeriod(c) {
        var sd = c.startTime.hhmm() == '00:00';
        var ed = c.endTime.hhmm() == '00:00';
        if (sd && ed) {
            if (Date.dateEquals(c.startTime, c.endTime)) {
                return c.startTime.yyyymmdd();
            }
            return c.startTime.yyyymmdd() + ' ' + $filter('translate')('to') + ' ' + c.endTime.yyyymmdd();
        }
        return c.startTime.dateTime() + ' ' + $filter('translate')('to') + ' ' + c.endTime.dateTime();
    }

    function getImage(course) {
        if (course.product && course.product.imagekey) {
            return $rootScope.image('product', course.product, 100);
        }

        if (course.category && course.category.imagekey) {
            return $rootScope.image('coursecategory', course.category, 100);
        }
    }

    function createConfig() {
        $scope.config = {
            api: {
                url: '/api/course/get',
                args: {
                    compact: true,
                    fields: 'id,product_id,product.name,product.price,staffs.name,startTime,bookings.id,workouts.id,endTime,category_id',
                    sites: $rootScope.selectedSite?.id || [],
                },
                triggers: [ {type: 'course'}, {type: 'coursebooking'}, {type: 'trainingcardtype'}],
                transform: courseutil.transformCourse,
                debounce: 300
            },
            empty: {
                title: 'Here you can offer courses',
                text: 'Courses make it possible to gather several activities into a coherent purchase for the customer.',
                button: { title: 'Create your first course', onClick: $scope.add }
            },
            tabs: buildTabs(),
            countSuffixList: ['course', 'courses'],
            rowClick: $scope.showCourse,
            giveFocus: function() {
                return false;
            },
            searchDepth: 3,
            columns: [
                {field: 'image', title: '', src: getImage},
                {field: 'product.name', title: 'Name' },
                {field: 'staffs', title: 'Instructor', getValue: function(c) { return c.staffs ? c.staffs.map(function(s) { return s.name; }).join(', ') : ''; }},
                {field: 'startTime', title: 'Date', getValue: getTimePeriod },
                {field: 'workouts', title: 'Sessions', format: 'count' },
                {field: 'bookings', title: 'Number of participants', format: 'count' },
                {field: 'product.price', title: 'Price incl. VAT', format: 'price' },
            ],
            orderColumn: 'product.name',
            buttons: [
                { title: 'Show participants', buttonClass: 'btn-info', visible: function() {return $rootScope.hasPermission('Schedule handling'); }, onClick: $scope.showCourse },
                { title: 'Change', buttonClass: 'btn-warning', visible: function() {return $rootScope.hasPermission('Schedule handling'); }, onClick: $scope.change },
                { title: 'Copy', buttonClass: 'btn-info', visible: function() {return $rootScope.hasPermission('Schedule handling'); }, onClick: $scope.copy },
                { title: 'Remove', buttonClass: 'btn-danger', visible: function() {return $rootScope.hasPermission('Schedule handling'); }, onClick: $scope.remove }
            ],
            searchButtons: [
                { title: 'Add course', showOnEmpty: true, onClick: $scope.add}
            ]
        };
    }
    $rootScope.waitFor(['coursecategories', 'trainingcardtypes']).then(function() {
        createConfig();
    });

    live.subscribe( {
        type: 'coursecategory',
        scope: $scope,
        callback: function() {
            $timeout(function() {
                createConfig();
            });
        }
    });

    $scope.pubsub('selectedSite', function() {
        createConfig();
    });
}]);

courses.controller('CourseCategoryListCtrl', ['$rootScope', '$scope', '$modal', 'server', function($rootScope, $scope, $modal, server) {
    $scope.add = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'CourseCategoryAddCtrl'
        });
    };

    $scope.change = function(coursecategory) {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'CourseCategoryChangeCtrl',
            resolve: {
                coursecategory: function() {
                    return coursecategory;
                }
            }
        });
    };

    $scope.canMoveUp = function(coursecategory) {
        var items = $scope.config.tabs[0].config.control.getItems();
        var index = items.indexOf(coursecategory);
        return index > 0;
    };

    $scope.canMoveDown = function(coursecategory) {
        var items = $scope.config.tabs[0].config.control.getItems();
        var index = items.indexOf(coursecategory);
        return index < items.length - 1;
    };

    $scope.up = function(coursecategory) {
        if ($scope.canMoveUp(coursecategory)) {
            var items = $scope.config.tabs[0].config.control.getItems();
            var index = items.indexOf(coursecategory);
            var one = coursecategory.order;
            var two = items[index-1].order;
            server.post('/api/course/category/reorder', null, {one: one, two: two});
        }
    };

    $scope.down = function(coursecategory) {
        if ($scope.canMoveDown(coursecategory)) {
            var items = $scope.config.tabs[0].config.control.getItems();
            var index = items.indexOf(coursecategory);
            var one = coursecategory.order;
            var two = items[index+1].order;
            server.post('/api/course/category/reorder', null, {one: one, two: two});
        }
    };

    $scope.inactivateModal = function(item, title, content, postUrl) {
        var modalInstance = $modal.open({
            templateUrl: 'views/inactivate.html',
            controller: 'ModalCtrl',
            resolve: {
                options: function() {
                    return {title: title, content: content};
                }
            }
        });

        modalInstance.result.then(function () {
            var data = {id: item.id, active: false};
            server.post(postUrl, data, null, '{0} was inactivated', 'Failed to inactivate {0}', title);
        });
    };

    $scope.activateModal = function(item, title, content, postUrl) {
        var modalInstance = $modal.open({
            templateUrl: 'views/activate.html',
            controller: 'ModalCtrl',
            resolve: {
                options: function() {
                    return {title: title, content: content};
                }
            }
        });

        modalInstance.result.then(function () {
            var data = {id: item.id, active: true};
            server.post(postUrl, data, null, '{0} was activated', 'Failed to activate {0}', title);
        });
    };

    function inactivate(r) {
        $scope.inactivateModal(r, r.name, 'REMOVE_CATEGORY_MESSAGE', '/api/course/category/change');
    }

    function activate(r) {
        $scope.activateModal(r, r.name, 'ACTIVATE_CATEGORY_MESSAGE', '/api/course/category/change');
    }

    var activeOnEmpty = {
        title: 'You have no active course categories. Add a new course category or activate inactive categories in the "Inactive" tab above.',
        button: { title: 'Add course category', onClick: $scope.add }
    };

    var inActiveOnEmpty = {
        title: 'Disabled categories will be collected here. They are then saved and can be activated again at a later time.',
        text: 'To deactivate a category, go to the "Active" tab above and press "Disable" on the category.'
    };


    $scope.config = {
        api: {
            url: '/api/course/category/get',
            triggers: [{type: 'coursecategory'}]
        },
        countSuffixList: ['category', 'categories'],
        giveFocus: function() { return false; },
        tabs: [
            { name: 'Active', badgeClass: 'badge-success', itemFilter: function(c) { return c.active; }, empty: activeOnEmpty },
            { name: 'Inactive', itemFilter: function(c) { return !c.active; }, empty: inActiveOnEmpty }
        ],
        columns: [
            {field: 'image', title: '', src: function(c) { return $rootScope.image('coursebookingcategory', c, 100); }},
            {field: 'name', title: 'Name'},
            {field: 'show', title: 'Show for customers', format: 'bool'}
        ],
        buttons: [
            {title: 'Change', buttonClass: 'btn-warning', onClick: $scope.change},
            {title: 'Move up', buttonClass: 'btn-warning', onClick: $scope.up, visible: function(c) { return c.active && $scope.canMoveUp(c); } },
            {title: 'Move down', buttonClass: 'btn-warning', onClick: $scope.down, visible: function(c) { return c.active && $scope.canMoveDown(c); }},
            {title: 'Activate', onClick: activate, buttonClass: 'btn-success', visible: function(c) {return !c.active; }},
            {title: 'Inactivate', onClick: inactivate, buttonClass: 'btn-danger', visible: function(c) {return c.active; }}
        ],
        searchButtons: [
            {title: 'Add course category', onClick: $scope.add, showOnEmpty: true}
        ]
    };
}]);

courses.controller('CourseCategoryAddCtrl', ['$rootScope', '$scope', '$controller', '$filter', function($rootScope, $scope, $controller, $filter) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.titleSuffix = function() {
        return $filter('translate')('course category');
    };

    $scope.postUrl = '/api/course/category/add';

    $scope.callCloseOnSuccess = true;

    $scope.setInitialValues = function() {
        _.findWhere($scope.fields, {name: 'sites'}).value = [$rootScope.selectedSite];
    };

    $scope.sortOptions = [
        { id: 'startTime', name: 'Start date' },
        { id: 'endTime', name: 'End date' },
        { id: 'name', name: 'Course name' },
        { id: 'created', name: 'Course created' }
    ];

    $scope.fields = [
        {value: 'The categories are displayed to the customer and will help them find the right course on your website.', type: 'alert', class: 'alert-info' },
        {name: 'name', title: 'Category name', type: 'text', required: true },
        {name: 'sites', title: 'Sites', required: true, type: 'multiselect', visible: function() { return $rootScope.hasModule('MultiSite'); }, options: function() { return $rootScope.sites; }, placeholder: 'Choose site', useId: true },
        {name: 'show', title: 'Show category for customers', type: 'checkbox', value: true},
        {name: 'imagekey', title: 'Image', type: 'field', field: 'image-storage', option: {originType: 'coursecategory', imageOnly: true, squareThumbnail: false} },
        {name: 'description', title: 'Description', type: 'htmleditor' }
    ];

    $scope.setInitialValues();
}]);

courses.controller('CourseCategoryChangeCtrl', ['$rootScope', '$scope', '$controller', 'coursecategory', function($rootScope, $scope, $controller, coursecategory) {
    $controller('CourseCategoryAddCtrl', {$scope: $scope});
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.titleSuffix = function() {
        return coursecategory.name;
    };

    $scope.item = coursecategory;

    $scope.postUrl = '/api/course/category/change';

    $scope.setValues($scope.item);
}]);

courses.controller('CourseUpdateResourcesQuestionModalCtrl', ['$scope', 'util', function($scope, util) {

    $scope.save = function() {
        var item = util.getSubmitItem($scope.fields);
        $scope.$close(item);
    };

    $scope.clearDontUpdate = function() {
        var updateStaffs = _.findWhere($scope.fields, { name: 'updateStaffs' }).value;
        var updateResources = _.findWhere($scope.fields, { name: 'updateResources' }).value;
        if (updateStaffs || updateResources) {
            _.findWhere($scope.fields, { name: 'dontUpdate' }).value = false;
        }
    };

    $scope.setDontUpdate = function() {
        var dontUpdate = _.findWhere($scope.fields, { name: 'dontUpdate' }).value;
        if (dontUpdate) {
            _.findWhere($scope.fields, { name: 'updateStaffs' }).value = false;
            _.findWhere($scope.fields, { name: 'updateResources' }).value = false;
        }
    };

    $scope.fields = [
        { name: 'updateStaffs', title: 'Update instructors on all course sessions (replaces the activities existing instructors)', type: 'checkbox', change: $scope.clearDontUpdate },
        { name: 'updateResources', title: 'Update resources on all course sessions (replaces the activities existing resources)', type: 'checkbox', change: $scope.clearDontUpdate },
        { name: 'dontUpdate', title: 'No thanks, keep the course instructors and resources set per activity', type: 'checkbox', change: $scope.setDontUpdate, value: true }
    ];
}]);

courses.controller('CourseDataCtrl', ['$rootScope', '$scope', '$modal', '$q', 'server', 'util', 'productCategoryService', 'accounts', 'paymentMethods', 'courseutil', 'options', function($rootScope, $scope, $modal, $q, server, util, productCategoryService, accounts, paymentMethods, courseutil, options) {
    function addCategory() {
        var modalInstance = $modal.open({ templateUrl: 'views/addmodal.html', controller: 'CourseCategoryAddCtrl' });
        modalInstance.result.then(function(addedCategory) {
            var c = $scope.config.control.getField('category_id');
            util.waitForNewObject(addedCategory.id, function(id) { return _.findWhere(c.options(), {id: id}); }, 'coursecategory').then(function(category) {
                c.value = category;
            });
        });
    }

    var workouts = [];
    $scope.setInitialWorkouts = true;

    function checkWorkoutTime(item) {
        let start = $scope.config.control.getField('startTime').value;
        let end = $scope.config.control.getField('endTime').value;
        return (item.startTime >= start && item.startTime <= end)
    }

    function workoutsSubmitable() {
        return !$scope.config.control.getField('workouts').value.find(x => !checkWorkoutTime(x));
    }

    function fetchWorkouts() {
        var start = $scope.config.control.getField('startTime').value;
        var end = $scope.config.control.getField('endTime').value;
        if (!start || !end || start.getFullYear() < 1900 || end.getFullYear() < 1900) {
            return;
        }

        server.get('/api/schedule/workout/get_simple', {fromDate: start.yyyymmdd(), toDate: end.yyyymmdd(), includeResources: true}).then(function(res) {
            res.forEach(function(w) {
                w.startTime = Date.newFull(w.s);
                var wt = $rootScope.getPointerById(w.t, $rootScope.workouttypes);
                w.name = wt.name;
            });
            workouts = _.uniq([...$scope.config.control.getField('workouts').value, ...res], false, (item)=>item.id);

            if ($scope.setInitialWorkouts) {
                var res = _.extend({}, $scope.config.item);
                _.extend(res, $scope.config.initial);
                var initialWorkouts = res.workouts || [];
                $scope.config.control.getField('workouts').value = initialWorkouts.map(function(workout_id) {
                    return _.findWhere(workouts, {id: workout_id});
                }).filter(function(x) { return x; });
                $scope.setInitialWorkouts = false;
            }
        });
    }

    function displayWorkout(workout) {
        return workout.name + ", " + workout.startTime.yyyymmdd() + ", " + workout.startTime.hhmm();
    }

    function addNewActivity() {
        var startTime = ($scope.config.control.getField('startTime').value || new Date()).clone();
        startTime.setHours(18,0);

        var modalInstance = util.showDataDialog({ controller: 'WorkoutDataCtrl', initial: {
            date: startTime,
            startTime: Date.newTime('18:00'),
            endTime: Date.newTime('19:00'),
            Staffs: $scope.config.control.getField('staffs').value || [],
            resources: $scope.config.control.getField('resources').value || []
        }});
        modalInstance.result.then(function(addedWorkouts) {
            var fieldWorkouts = $scope.config.control.getField('workouts');
            var linkedWorkouts = (fieldWorkouts.value === undefined) ? [] : fieldWorkouts.value;
            if (!Array.isArray(addedWorkouts)) {
                addedWorkouts = [addedWorkouts];
            }
            addedWorkouts.forEach(function(addedWorkout) {
                addedWorkout = $rootScope.transformWorkout(addedWorkout);
                var staffs = _.pluck(addedWorkout.Staffs || [], 'id');
                var resources = _.pluck(addedWorkout.resources || [], 'id');
                addedWorkout = { id: addedWorkout.id, s: addedWorkout.startTime.dateTime(), t: addedWorkout.workoutType.id, name: addedWorkout.workoutType.name, startTime: addedWorkout.startTime, staffs: staffs, resources: resources };
                linkedWorkouts.push(addedWorkout);
            });
            workouts.push.apply(workouts, linkedWorkouts);
            fieldWorkouts.value = linkedWorkouts;
        });
    }

    function getProductCategory(t) {
        return t.type ? t.type.capitalize() : 'Product';
    }

    function includedProductFilter(t) {
        if (options.item && options.item.included_products && options.item.included_products.indexOf(t.id) >= 0) {
            return true;
        }      

        return t.active && !$rootScope.isPackageProduct(t) && (t.type == 'membership' || t.type == 'trainingcard' || t.type == 'resourcebooking' || !t.type);
    }

    function additionalProductFilter(t) {
        return t.active && !t.valuecard && !$rootScope.isPackageProduct(t);
    }

    function showWebshopCategory() {
        if ($rootScope.hasFlag('flag-unified-sales-category')) {
            return true;
        } else {
            var customerCanBuy = $scope.config.control.getField('product.customerCanBuy');
            return customerCanBuy && customerCanBuy.visible() && customerCanBuy.value;
        }
    }

    function showCostCenter() {
        return $scope.config.data.costcenters && $scope.config.data.costcenters.length;
    }

    function showMethods() {
        return $rootScope.hasModule('WebShop') && $scope.config.control.getField('product.customerCanBuy').value;
    }

    function getWebShopMethodName(method) {
        return method.id == 'unknown' ? 'Pay on site' : method.name;
    }

    function getTrainingPunchCard() {
        return $rootScope.trainingcardtypes.filter(function(cardtype) {
            return cardtype.active && cardtype.type === 'trainingcard' && cardtype.trainingsessions != null;
        });
    }

    function changeCancelRules() {
        $modal.open({
            templateUrl: 'views/cancelrules.html',
            controller: 'CancelRulesCtrl',
            windowClass: 'large-modal-window',
            resolve: {
                rules: function() {
                    return $scope.config.control.getField('cancelRules').value;
                },
                lastCancelTime: function() {
                    var value = $scope.config.control.getField('lastCancelTime').value;
                    return {
                        value: value.value,
                        timeunit: value.timeunit.id,
                        relative: value.relative.id
                    };
                }
            }
        }).result.then(function(rules) {
            $scope.config.control.getField('cancelRules').value = rules;
        });
    }

    function showAddCancelRules() {
        var canCancel = $scope.config.control.getField('canCancel').value;
        var cr = $scope.config.control.getField('cancelRules');
        return canCancel && cr && (!cr.value || !cr.value.length);
    }

    function hasCancelRules() {
        var canCancel = $scope.config.control.getField('canCancel').value;
        var cr = $scope.config.control.getField('cancelRules');
        return canCancel && cr && cr.value && cr.value.length;
    }

    function cancelRulesInvalid() {
        function ruleDateInvalid(time, lc) {
            lc = util.normalizeRelativeTime(lc);
            time = util.normalizeRelativeTime(time);
            if (lc.relative == 'beforestart' && time.relative == 'afterstart') {
                return true;
            }
            if (lc.relative == 'afterstart' && time.relative == 'beforestart') {
                return false;
            }

            var a = util.getHoursFromRelativeTime(time.value, time.timeunit);
            var b = util.getHoursFromRelativeTime(lc.value, lc.timeunit);
            if (lc.relative == 'afterstart') {
                // 17 veckor efter kursstart
                // must be less than
                return !(a <= b);
                
            } else if (lc.relative == 'beforestart') {
                // 13 veckor före kursstart
                // must be more than
                return !(a >= b);
            }
        }

        var lc = $scope.config.control.getField('lastCancelTime').value;
        var rules = $scope.config.control.getField('cancelRules').value;
        return rules && !!rules.find(function(rule) { return ruleDateInvalid(rule.time, lc); });
    }

    var bookForOthersFields = [];
    function getBookForOthersFields() {
        server.get('/api/settings/fields/get').then(function(fields) {
            bookForOthersFields = fields.user.filter(function(field) { return field.child; });
        });
    }
    getBookForOthersFields();

    function getBookForOthersFieldsHtml() {
        return '<label style="font-weight: normal">' + bookForOthersFields.map(function(field) {
            return util.t(field.title) + (field.required_child ? '*' : '');
        }).join(', ') + '</label><div><i>Detta ändras under inställningar - kundinformation och gäller för alla bokningar och köp åt andra</i></div>';
    }

    function includedProductAmountTooHigh() {
        var amounts = $scope.config.control.getField('included_products_amount').value;
        if(amounts == null) {return false;}
        var total = 0;
        Object.values(amounts).forEach(function(value) {
            total += Number(value);
        });

        var price = $scope.config.control.getField('product.price').value;

        return total > Number(price);
    }

    function isDateUnreasonable(fieldName) {
        var val = $scope.config.control.getField(fieldName).value;
        if (!val) return false;
        var twoYearsFromNow = new Date();
        twoYearsFromNow.setFullYear(twoYearsFromNow.getFullYear() + 2);
        return val > twoYearsFromNow;
    }

    function onChangeStartTime() {
        var start = $scope.config.control.getField('startTime').value;
        var lastBookingTime = $scope.config.control.getField('lastBookingTime');

        if (start && !lastBookingTime.value) {
            lastBookingTime.value = start.clone();
        }

        fetchWorkouts();
    }

    function clearSitesField() {
        $scope.config.control.getField('sites').value = [];
    }

    $scope.ages = [];
    for (var i = 0; i < 100; ++i) {
        $scope.ages.push({'id': i, 'name': i});
    }

    var setAge = function(field, value) {
        if (value) {
            return {from: _.findWhere($scope.ages, {id: value.from}), to: _.findWhere($scope.ages, {id: value.to})};
        }
    };

    var bookForOtherOptions = [
        {id: 'self', name: 'Only for oneself'},
        {id: 'self+others', name: 'Primarily for oneself'},
        {id: 'others+self', name: 'Primarily for others'},
        {id: 'others', name: 'Only for others'}
    ];

    var isChange = !!(options.item);
    $scope.config = _.deep_extend(options.config, {
        datatype: 'course',
        data: {
            productsAndTrainingCards: $rootScope.getActiveProducts().concat($rootScope.getActiveTrainingCards()),
            costcenters: $rootScope.hasPermission('Accounting') && $rootScope.waitFor(['costcenters'])
        },
        url: {
            add: '/api/course/add',
            change: '/api/course/change'
        },
        tabs: [
            {
                name: 'Course information',
                fields: [
                    {name: 'category_id', title: 'Course category', required: true, type: 'select', options: function() { return $rootScope.coursecategories; }, optionsFilter: {active: true}, useId: true, addButtonClicked: addCategory, addButtonTitle: 'New category', helpText: 'HELPTEXT_COURSE_CATEGORY', noResultsText: 'Start by creating a category' },
                    {name: 'product.name', title: 'The course name', required: true, type: 'text'},
                    {name: 'subtitle', title: 'Course subtitle', required: false, type: 'text', helpText: 'Course subtitle help'},
                    {name: 'product.imagekey', title: 'Image', type: 'field', field: 'image-storage', option: {originType: 'product', imageOnly: true, squareThumbnail: true}},
                    {name: 'product.description', title: 'Short description 2', required: true, type: 'htmleditor', helpText: 'HELPTEXT_COURSE_SHORT_DESCRIPTION'},
                    {name: 'longdescription', title: 'Long description', required: true, type: 'htmleditor', helpText: 'HELPTEXT_COURSE_DESCRIPTION'},
                    {name: 'sites', title: 'Sites', required: true, type: 'multiselect', visible: function() { return $rootScope.hasModule('MultiSite'); }, options: function() { return $rootScope.sites; }, addButtonClicked: clearSitesField, addButtonClass: 'btn-light', addButtonTitle: 'Clear', placeholder: 'Choose site', useId: true },
                    {name: 'staffs', title: 'Instructors', required: false, type: 'customers', itemTypes: ['staff'], useId: true, helpText: util.t('COURSE_UPDATE_INSTRUCTOR').format(util.t(isChange?'Change':'Add')) },
                    {name: 'resources', title: 'Resources', required: false, type: 'customers', itemTypes: ['resource'], useId: true, helpText: util.t('COURSE_UPDATE_RESOURCE').format(util.t(isChange?'Change':'Add')) },
                    {name: 'tags', title: 'Tags', required: false, type: 'systemtag' }
                ]
            },
            {
                name: 'Content',
                fields: [
                    {name: 'startTime', title: 'Course starts', required: true, type: 'datetime', change: onChangeStartTime},
                    {hint: 'The start date is more than 2 years in the future, is this correct?', hintClass: 'alert-warning', hintCompact: true, visible: function() { return isDateUnreasonable('startTime'); }},
                    {name: 'endTime', title: 'Course ends', required: true, type: 'datetime', change: fetchWorkouts},
                    {hint: 'The end date is more than 2 years in the future, is this correct?', hintClass: 'alert-warning', hintCompact: true, visible: function() { return isDateUnreasonable('endTime'); }},
                    {name: 'workouts', title: 'Add course sessions', type: 'multiselect', options: ()=>{return workouts}, useId: true, getName: displayWorkout, placeholder: 'Choose linked workouts', addButtonClicked: addNewActivity, addButtonTitle: 'Create new activity', helpText: 'HELPTEXT_COURSE_SESSIONS', noResultsText: 'Fill in start and end time', orderPredicate: 'startTime'},
                    {hint: 'Workouts not in selected time period', hintClass: 'alert-danger', visible: ()=>!workoutsSubmitable()},
                    {name: 'paybackTraningcardsBool', title: 'Repay to punch card', type: 'checkbox', required: false, visible: function() { var v = $scope.config.control.getField('workouts').value; return v && v.length; } },
                    {name: 'paybackTraningcard_id', title: 'Select punch card', type: 'select', visible: 'paybackTraningcardsBool', options: getTrainingPunchCard, useId: true, hint: 'PAYBACK_COURSE_HINT' },
                    {name: 'included_products', title: 'Included products', type: 'multiselect', options: function() { return $rootScope.trainingcardtypes;}, optionsFilter: includedProductFilter, placeholder: 'Choose products', useId: true, group: getProductCategory, helpText: 'HELPTEXT_COURSE_INCLUDED_PRODUCTS' },
                    {name: 'included_products_amount'},
                    {hint: 'Sum cannot be higher than the service price', hintClass: 'alert-danger', visible: includedProductAmountTooHigh },
                    {name: 'additional_products', title: 'Additional products', type: 'multiselect', options: function() { return $scope.config.data.productsAndTrainingCards; }, optionsFilter: additionalProductFilter, placeholder: 'Choose products', useId: true, group: getProductCategory, helpText: 'HELPTEXT_ADDITIONAL_PRODUCTS' },
                    {name: 'url', title: util.t('LINKTO').format(util.t('course')), type: 'url', visible: function() { return $rootScope.zoeziMyBusiness; } }
                ]
            },
            {
                name: 'Booking',
                fields: [
                    {name: 'space', title: 'Number of places on course', placeholder: 'Unlimited', required: false, type: 'number', helpText: 'HELPTEXT_COURSE_PLACES' },
                    {name: 'firstBookingTime', title: 'Booking opens', required: true, type: 'datetime'},
                    {name: 'lastBookingTime', title: 'Booking closes', required: true, type: 'datetime'},
                    {name: 'canBookFor', type: 'select', required: true, title: 'Customer books', visible: function() { return $rootScope.zoeziMyBusiness; }, options: function() { return bookForOtherOptions; }, useId: true, orderPredicate: 'none' },
                    {title: 'Customer information when booking for others', type: 'html', visible: function() { var f = $scope.config.control.getField('canBookFor').value; return f && f.id && f.id.includes('others');}, getValue: getBookForOthersFieldsHtml },
                    {name: 'questions', title: 'Questions', required: false, type: 'multifields', options: { itemTitle: 'question' }, helpText: 'HELPTEXT_COURSE_QUESTIONS' },
                    {name: 'purchase_age', title: 'Age for purchase', required: false, type: 'interval', options: function() { return $scope.ages; }, getValue: getIntervalValue, setValue: setAge, changed: function(field) { return !angular.equals(field.getValue(field), ($scope.course || {}).purchase_age); }, visible: function() { return $rootScope.hasModule('WorkoutBookingRules'); } },
                    {name: 'product.requireMembership', title: 'Require membership', required: false, type: 'checkbox', visible: function() { return $rootScope.hasModule('Membership'); } },
                    {name: 'product.customerCanBuy', title: 'Show in web shop', required: false, type: 'checkbox', visible: function() { return $rootScope.hasModule('WebShop'); }, helpText: 'HELPTEXT_COURSE_CAN_BUY' },
                    productCategoryService.makeWebshopSelectField({ name: 'product.product_webshop_category_id', visible: showWebshopCategory })
                ]
            },
            {
                name: 'Cancellation',
                visible: function() { return $rootScope.zoeziMyBusiness; },
                fields: [
                    {name: 'canCancel', title: 'Allow customer to cancel', type: 'checkbox'},
                    {name: 'lastCancelTime', title: 'Can be cancelled by customer until', type: 'relativetime', visible: 'canCancel', required: true, timeunits: function() { return util.timeunits; }, relative: function() { return util.relative; }, helpText: 'HELPTEXT_COURSE_LAST_CANCEL_TIME'},
                    {title: 'Cancellation policy', type: 'button', buttonTitle: 'Add', buttonClass: 'btn btn-success', visible: showAddCancelRules, click: changeCancelRules },
                    {title: 'Cancellation policy', type: 'html', getValue: function() { return courseutil.getCancelPolicyListHtml($scope.config.control.getField('cancelRules').value); }, visible: hasCancelRules},
                    {name: 'cancelRules', type: 'button', buttonTitle: 'Change', buttonClass: 'btn btn-warning', visible: hasCancelRules, click: changeCancelRules, doSubmit: true },
                    {type: 'label', value: 'COURSE_CANCEL_RULES_INVALID', format: 'translated', visible: cancelRulesInvalid, getClass: function() { return 'text-danger'; }},
                    {name: 'refundProducts', title: 'Cancel and refund additional products', type: 'checkbox', visible: 'canCancel', helpText: 'HELPTEXT_COURSE_REFUND_PRODUCTS'}
                ]
            },
            {
                name: 'Price',
                fields: [
                    {name: 'product.price', title: 'Price incl. VAT', required: true, type: 'price' },
                    {name: 'product.vat', title: 'VAT', required: true, type: 'select', options: function() { return $rootScope.valueAddedTax; }, useId: true, visible: function() { return !$rootScope.vatexempt; }, orderPredicate: 'id' },
                    accounts.getFieldsRow($scope, function() { return $rootScope.hasPermission('Accounting'); }, null, null, null, 'product.account'),
                    {name: 'product.methods', title: 'Payment methods', type: 'multiselect', visible: showMethods, options: paymentMethods.getPossibleForWebshop, placeholder: 'All payment methods', getName: getWebShopMethodName, useId: true, helpText: 'HELPTEXT_PAYMENT_METHOD' },
                    {name: 'product.costcenter_id', title: 'Cost center', type: 'select', options: function() { return $scope.config.data.costcenters; }, visible: showCostCenter, useId: true, helpText: 'HELPTEXT_COURSE_COST_CENTER'},
                    {name: 'product.receiptComment', title: 'Comment on receipt', type: 'textarea' }
                ]
            }
        ],
        initCallChange: true,
        init: function() {
            if (!options.item) {
                return {
                    product: {
                        customerCanBuy: true,
                        vat: !$rootScope.vatexempt && '25'
                    },
                    sites: [$rootScope.selectedSite],
                    canCancel: true,
                    lastCancelTime: {
                        value: 1,
                        timeunit: 'day',
                        relative: 'beforestart'
                    },
                    canBookFor: 'self',
                    included_products: [],
                    included_products_amount: {},
                    firstBookingTime: new Date()
                };
            } else if (options.item && (!options.item.lastCancelTime || !_.isObject(options.item.lastCancelTime))) {
                $scope.config.initial = {
                    lastCancelTime: {
                        value: 1,
                        timeunit: 'day',
                        relative: 'beforestart'
                    }
                };
            }
        },
        canSubmit: function() {
            return !$scope.setInitialWorkouts && !cancelRulesInvalid() && !includedProductAmountTooHigh() && workoutsSubmitable();
        },
        beforeSubmit: function(item) {
            var deferred = $q.defer();
            if (!isChange) {
                deferred.resolve(item);
                return deferred.promise;
            }

            var askIfShouldUpdate = false;
            var original = $scope.config.item;

            var hasChanged = function(original, updated) {
                return original.length != updated.length || _.intersection(original, updated).length != updated.length;
            };

            var original_staffs = _.pluck(original.staffs || [], 'id');
            if (hasChanged(original_staffs, item.staffs)) {
                askIfShouldUpdate = true;
            } else {
                var resources = _.pluck(original.resources || [], 'id');
                if (hasChanged(resources, item.resources)) {
                    askIfShouldUpdate = true;
                }
            }

            if (askIfShouldUpdate) {
                var futureWorkouts = _.filter($scope.config.control.getField('workouts').value || [], function(w) { return w.startTime.isFuture(); });
                if (!futureWorkouts.length) {
                    askIfShouldUpdate = false;
                } else {
                    askIfShouldUpdate = !!_.find(futureWorkouts, function(workout) {
                        return hasChanged(workout.staffs, item.staffs) || hasChanged(workout.resources, item.resources);
                    });
                }
            }

            if (!askIfShouldUpdate) {
                deferred.resolve(item);
            } else {
                $modal.open({
                    templateUrl: 'views/courseupdateresourcesquestionmodal.html',
                    controller: 'CourseUpdateResourcesQuestionModalCtrl'
                }).result.then(function(options) {
                    item.options = options;
                    deferred.resolve(item);
                }, deferred.reject);
            }

            return deferred.promise;
        }
    });

    // Included products
    (function() {
        var fields = _.findWhere($scope.config.tabs, {name: 'Content'}).fields;
        var fieldIncludedProducts = _.findWhere(fields, {name: 'included_products'});
        var fieldProductMap = _.findWhere(fields, {name: 'included_products_amount'});

        util.setupCustomMapField($scope, fieldIncludedProducts, fieldProductMap, {
            title: 'Price for product',
            visible: function() {
                return fieldIncludedProducts.value && fieldIncludedProducts.value.length;
            },
            getNameByKey: function(key) {
                var product = _.findWhere($rootScope.trainingcardtypes, {id: Number(key)});
                return product ? product.name : key;
            }
        });
    })();
}]);

courses.directive('cancelrule', ['$controller', 'courseutil', 'util', function($controller, courseutil, util) {
    return {
        restrict: 'E',
        templateUrl: 'views/form.html',
        scope: {
            rule: '=',
            lastCancelTime: '='
        },
        link: function($scope) {
            $controller('AddCtrl', {$scope: $scope});

            function updateRule() {
                var time = _.findWhere($scope.fields, {name: 'time'}).value;
                $scope.rule.time.value = time.value;
                $scope.rule.time.timeunit = time.timeunit.id;
                $scope.rule.time.relative = time.relative.id;
                $scope.rule.cost_percent = _.findWhere($scope.fields, {name: 'cost_percent'}).value;
                $scope.rule.cost_fixed = _.findWhere($scope.fields, {name: 'cost_fixed'}).value;
            }

            function ruleDateInvalid() {
                var time = _.findWhere($scope.fields, {name: 'time'}).value;
                if (!time.value) {
                    return false;
                }
                var lc = $scope.lastCancelTime;
                if (lc.relative == 'beforestart' && time.relative.id == 'afterstart') {
                    return true;
                }
                if (lc.relative == 'afterstart' && time.relative.id == 'beforestart') {
                    return false;
                }

                var a = util.getHoursFromRelativeTime(time.value, time.timeunit.id);
                var b = util.getHoursFromRelativeTime(lc.value, lc.timeunit);
                if (lc.relative == 'afterstart') {
                    // 17 veckor efter kursstart
                    // must be less than
                    return !(a <= b);
                    
                } else if (lc.relative == 'beforestart') {
                    // 13 veckor före kursstart
                    // must be more than
                    return !(a >= b);
                }
            }

            $scope.fields = [
                {name: 'time', title: 'Time of cancellation', type: 'relativetime', required: true, timeunits: function() { return util.timeunits; }, relative: function() { return util.relative; }, change: updateRule },
                {type: 'label', value: 'COURSE_CANCEL_DATE_INVALID', format: 'translated', visible: ruleDateInvalid, getClass: function() { return 'text-danger'; }},
                {name: 'cost_percent', title: 'Cost of cancellation', type: 'infoNumber', info: '% of the course price', min: 0, max: 100, change: updateRule, helpText: 'HELPTEXT_CANCELLATION_COST'},
                {name: 'cost_fixed', type: 'price', change: updateRule}
            ];

            util.setValues($scope.fields, angular.copy($scope.rule));
        }
    };
}]);

// FIXME: This can quite easily be used for all kind of bookings
courses.controller('CancelRulesCtrl', ['$rootScope', '$scope', '$controller', 'util', 'rules', 'lastCancelTime', function($rootScope, $scope, $controller, util, rules, lastCancelTime) {
    $controller('AddCtrl', {$scope: $scope});
    $scope.title = (rules && rules.length) ? 'Change' : 'Add';

    $scope.titleSuffix = function() {
        return util.t('Cancellation policy').toLowerCase();
    };

    $scope.remove = function(rule) {
        $scope.rules.splice($scope.rules.indexOf(rule), 1);
    };

    $scope.add = function() {
        $scope.rules.push({ time: {value: null, timeunit: 'week', relative: 'beforestart'}, cost_fixed: null, cost_percent: null});
    };

    $scope.rules = angular.copy(rules) || [];
    if (!$scope.rules.length) {
        $scope.add();
    }
    $scope.lastCancelTime = lastCancelTime;

    $scope.submit = function() {
        $scope.$close($scope.rules);
    };
}]);

courses.controller('CourseCopyCtrl', ['$rootScope', '$scope', '$controller', '$modal', '$q', 'course', 'newCourse', 'util', 'server', function($rootScope, $scope, $controller, $modal, $q, course, newCourse, util, server) {
    $controller('AddCtrl', {$scope: $scope});
    $scope.title = 'Book participants';

    $scope.setInitialValues = function() {
        var methods = $rootScope.paymentmethods || [];
        var method = _.findWhere(methods, {id: 'unknown'});
        _.findWhere($scope.fields, {name: 'method'}).value = method;
        _.findWhere($scope.fields, {name: 'date'}).value = Date.today();
    };

    $scope.fields = [
        {name: '_', hint: 'COURSE_COPIED_BOOKINGS'},
        {name: 'participants', title: 'Participants', type: 'customers', required: false, useId: true, value: course.bookings && course.bookings.map(function(b) { return b.user; })},
        {name: 'method', title: 'Payment method', required: true, type: 'paymentmethod',options: {create: true}},
        {name: 'date', title: 'Due date', required: true, type: 'date'},
    ];
    $scope.setInitialValues();

    var doCopy = function() {
        var selectedParticipants = _.findWhere($scope.fields, {name: 'participants'}).value;
        var submitItems = selectedParticipants.map(function(sp) {
            var submitItem = {};
            var dueDate = Date.newFull(_.findWhere($scope.fields, {name: 'date'}).value).yyyymmdd();
            var booking = _.findWhere(course.bookings, {user_id: sp.id});
            var paymentMethod = _.findWhere($scope.fields, {name: 'method'}).value?.id || 'unknown';
            if (booking) {
                booking.additional_products = booking.additional_products.filter(function(ap) { return booking.additional_products.indexOf(ap.id) != -1; });
                var booker_id = booking.booker ? booking.booker.id : null;
                var payer_id = (booking.payments[0] && booking.payments[0].payer_id) || booker_id;
                submitItem = { user_id: sp.id, booker_id: booker_id, payer_id: payer_id, additional_products: booking.additional_products, method: paymentMethod, duedate: dueDate, course_id: newCourse.id };
            } else {
                submitItem = { user_id: sp.id, additional_products: [], method: paymentMethod, duedate: dueDate, course_id: newCourse.id };
            }
            return submitItem;
        });
        server.post('/api/course/booking/add', submitItems, {addFrom: 'copy'}, 'Course was added', 'Failed to add course').then(function(result) {
            if (result.success) {
                $scope.$close();
                $scope.afterSubmit(result);
            } else {
                $scope.loadingStatus.loading = false;
            }
        });
    };

    $scope.afterSubmit = function(result) {
        if (result) {
            var success;
            if (result.data.success.length) {
                success = util.t('{0} persons booked').format(result.data.success.length);
            }
            var failed;
            var failedNames;
            if (result.data.failed.length) {
                failed = util.t('Failed to add booking for the following {0} persons').format(result.data.failed.length);
                failedNames = [];
                result.data.failed.forEach(function(u) {
                    var u = $rootScope.getMember(u);
                    failedNames.push(u ? u.name : util.t('Anonymous'));
                });
            }
            if (success || failed) {
                $modal.open({
                    templateUrl: 'views/groupbookingdone.html',
                    controller: 'ModalCtrl',
                    resolve: {
                        options: function() {
                            return {title: 'Booking completed', success: success, failed: failed, failedNames: failedNames };
                        }
                    }
                });
            }
        }
    };

    $scope.canSubmit = function() {
        var p = _.findWhere($scope.fields, {name: 'participants'}).value;
        return p && p.length;
    };

    $scope.submit = function() {
        $scope.loadingStatus.loading = true;
        doCopy();
    };
}]);

courses.controller('CourseCtrl', ['$rootScope', '$scope', '$modal', '$filter', 'confirm', 'server', 'live', 'courseutil', 'util', 'workoutProvider', 'course', 'CreditPaymentDialog', function($rootScope, $scope, $modal, $filter, confirm, server, live, courseutil, util, workoutProvider, course, CreditPaymentDialog) {
    $scope.course = course;

    $scope.sendMailing = function(items) {
        $scope.pubsub.publish('newmailingdata', {
            isNewsOrAdvertising: false,
            sendOption: 'mail',
            receivers: items,
            options: { 'callCloseOnSuccess': true, 'modalMode': false }
        });
        $modal.open({
            templateUrl: 'views/mailingnew.html',
            windowClass: 'huge-modal-window',
            controller: 'NewMailingCtrl'
        });
    };

    $scope.getExcel = function() {
        var config = $scope.config.control.getActiveTab().config;
        config.control.exportTo('excel').then(function(blob) {
            util.download(config.getTitle() + '.xlsx', null, null, blob);
        });
    };

    $scope.changeBooking = function(booking) {
        $modal.open({
            templateUrl: 'views/coursebookingchangemodal.html',
            controller: 'CourseBookingChangeCtrl',
            resolve: {
                options: function() {
                    return {
                        booking: booking,
                        course: course
                    };
                }
            }
        });
    };

    $scope.removeBooking = function(booking) {
        CreditPaymentDialog.open({
            courseBookingId: booking.id
        });
    };

    $scope.addBooking = function() {
        $modal.open({
            templateUrl: 'views/coursebookingaddmodal.html',
            controller: 'CourseBookingAddCtrl',
            resolve: {
                options: function() {
                    return {
                        course: course
                    };
                }
            }
        });
    };

    $scope.addWatcher = function() {
        var modalInstance = $modal.open({
            templateUrl: 'views/getcustomermodal.html',
            controller: 'GetCustomerCtrl',
            windowClass: 'huge-modal-window',
            resolve: {
                options: function() {
                    return {
                        itemFilter: function(user) {
                            return !course.watchers.find(function(w) {
                                return w.user_id == user.id;
                            });
                        }
                    };
                }
            }
        });

        modalInstance.result.then(function (customer) {
            server.post('/api/course/watch/add', null, {course_id: course.id, user_id: customer.id});
        });
    };

    $scope.full = function() {
        return course.spaceLeft == 0;
    };

    function isExcel(format) {
        return format == 'excel';
    }

    function isNotExcel(format) {
        return format != 'excel';
    }

    function createColumns(columns) {
        (course.questions || []).forEach(function(q) {
            var qname = q.name.replaceAll('.', '');
            columns.push({field: 'answers.' + qname, title: q.name, visible: isExcel, splitted_name: ['answers', q.name] });
        });
        
        (course.included_products || []).forEach(function(product_id) {
            var product = _.findWhere($rootScope.trainingcardtypes, {id: Number(product_id)});
            if (product && product.variants && product.variants.length > 1) {
                columns.push({field: 'included.' + product.id, title: product.name, visible: isExcel, splitted_name: ['included', product.id], getValue: function(o) { return o.variants_for_included_products && o.variants_for_included_products[product.id]; }});
            }
        });

        return columns;
    }

    $scope.workouts = [];
    function fetchWorkouts() {
        course.workouts.forEach(function(workout_id) {
            workoutProvider.getWorkoutById(workout_id).then(function(w) {
                $scope.workouts.push(w);
            });
        });
    }
    fetchWorkouts();

    $scope.displayWorkout = function(workout) {
        return workout.workoutType.name + ", " + workout.startTime.yyyymmdd() + ", " + workout.startTime.hhmm() + " - " + workout.endTime.hhmm();
    };

    function getAdditionalProducts(b) {
        if (b.additional_products) {
            return b.additional_products.map(function(a) {
                var prefix = '';
                if (a.count > 1) {
                    prefix = a.count + ' x ';
                }
                return {name: prefix + $rootScope.getPointerById(a.id, $rootScope.trainingcardtypes).name };
            });
        }
    }

    function getPaymentStatus(b) {
        var allPaid = _.all(b.payments, function (p) {
            return p.status == 'paid';
        });
        return allPaid ? $filter('translate')('Paid') : $filter('translate')('UNPAID_ONE');
    }

    function needBookerColumn() {
        return course.bookings.find(function(b) {
            return b.user_id != b.booker_id;
        });
    }

    function visibleColumn(config, column) {
        if (config.context && config.context.columns) {
            return config.context.columns.indexOf(column.field) != -1;
        }
    }

    $scope.removeWatcher = function(b) {
        server.post('/api/course/watch/remove', null, {course_id: course.id, user_id: b.user.id});
    };

    function getUsersAndBookers() {
        var items = $scope.config.control.getActiveTab().config.control.getItems();
        return _.uniq(_.pluck(items, 'user').concat(_.pluck(items, 'booker')));
    }

    function sendMailing() {
        $scope.sendMailing(getUsersAndBookers());
    }

    var bookingsAndWatchers = null;
    $scope.config = {
        getItems: function() {
            if (!bookingsAndWatchers) {
                var watchers = course.watchers.map(function(watcher) {
                    var user = $rootScope.getMember(watcher.user_id);
                    return {
                        id: watcher.id,
                        user: user,
                        booker: user,
                        watcher: true,
                    };
                });
                bookingsAndWatchers = course.bookings.concat(watchers);
            }
            return bookingsAndWatchers;
        },
        getTitle: function() {
            return course.product.name + ' - ' + $filter('translate')($scope.config.control.getActiveTab().name);
        },
        rowClick: function(b) {
            $scope.$close();
            $rootScope.gotoCustomer(b.user);
        },
        tabs: [
            {name: 'GENERAL_BOOKINGS', badgeClass: 'badge-success', itemFilter: function(b) { return !b.watcher; }, context: { columns: ['image', 'user.name', 'booker.name', 'additional_products', 'pStatus'] } },
            {name: 'Watching', badgeClass: 'badge-warning', itemFilter: function(b) { return b.watcher; }, context: { columns: ['image', 'user.name'] } }
        ],
        searchDepth: 2,
        countSuffixList: ['booking', 'GENERAL_BOOKINGS'],
        columns: createColumns([
            {field: 'image', title: '', src: function(b) { return $rootScope.smallMemberImage(b.user); } },
            {field: 'user.firstname', title: 'First name', visible: isExcel },
            {field: 'user.lastname', title: 'Last name', visible: isExcel },
            {field: 'user.birthdate', title: 'Birthdate', format: 'date', visible: isExcel },
            {field: 'user.name', title: 'Name', click: function(item) { $rootScope.gotoCustomer(item.user); }, visible: isNotExcel },
            {field: 'booker.name', title: 'Booker', visible: function(config, column) { return visibleColumn(config, column) && needBookerColumn(); }, click: function(item) { $rootScope.gotoCustomer(item.booker); } },
            {field: 'additional_products', title: 'Additional products', getValue: function(b) { return b.additional_products && b.additional_products.length > 0; }, format: 'bool', visible: function(config, column) { return visibleColumn(config, column) && isNotExcel(); } },
            {field: 'additional_products', title: 'Additional products', format: 'commaList', visible: isExcel, getValue: getAdditionalProducts },
            {field: 'user.mail', title: 'E-mail', visible: isExcel },
            {field: 'user.phone', title: 'Phone', visible: isExcel },
            {field: 'pStatus', title: 'Paid', getValue: getPaymentStatus, visible: function(config, column) { return visibleColumn(config, column) || isExcel(config); } }
        ]),
        buttons: [
            {title: 'Show', buttonClass: 'btn-info', visible: function(b) { return !b.watcher && $rootScope.hasPermission('Workout booking'); }, onClick: $scope.changeBooking },
            {title: 'CANCEL_BOOKING', buttonClass: 'btn-danger', visible: function(b) { return !b.watcher && $rootScope.hasPermission('Workout booking'); }, onClick: $scope.removeBooking },
            {title: 'Remove', buttonClass: 'btn-danger', visible: function(b) { return b.watcher && $rootScope.hasPermission('Workout booking'); }, onClick: $scope.removeWatcher }
        ],
        searchButtons: [
            {title: 'Send mailing', onClick: sendMailing, visible: function() {return $rootScope.hasPermission('Mailing handling');} },
            {title: 'Download as Excel', onClick: $scope.getExcel, showOnEmpty: false, buttonClass: 'btn btn-info' },
            {title: 'Add booking', showOnEmpty: true, visible: function(config) { return config.name == 'GENERAL_BOOKINGS'; }, onClick: $scope.addBooking, disabled: $scope.full },
            {title: 'Add watcher', showOnEmpty: true, visible: function(config) { return config.name == 'Watching'; }, onClick: $scope.addWatcher }
        ]
    };

    function fetchCourse() {
        server.get('/api/course/get', {id: course.id}).then(function(data) {
            course = courseutil.transformCourse(data);
            bookingsAndWatchers = null;
            $scope.config.control.rebuild();
        }); 
    }

    live.subscribe( {
        type: 'coursebooking',
        scope: $scope,
        callback: fetchCourse
    });

    live.subscribe( {
        type: 'course',
        scope: $scope,
        callback: function(c) {
            if (c.id == course.id) {
                fetchCourse();
            }
        }
    });
}]);

courses.controller('CourseBookingAddCtrl', ['$rootScope', '$scope', '$controller', '$filter', '$modal', '$injector', 'server', 'paymentMethods', 'util', 'modalUtils', 'confirm', 'courseutil', 'options', function($rootScope, $scope, $controller, $filter, $modal, $injector, server, paymentMethods, util, modalUtils, confirm, courseutil, options) {
    $controller('AddCtrl', {$scope: $scope});
    $scope.course = options.course;

    $scope.titleSuffix = function() {
        return $filter('translate')('booking') + ' ' + $filter('translate')('to') + ' ' + ($scope.course ? $scope.course.name : $filter('translate')('course'));
    };

    $scope.postUrl = '/api/course/booking/add';
    $scope.successTitle = '{0} was added';
    $scope.failedTitle = 'Failed to add {0}';
    $scope.itemTitle = 'Booking';
    $scope.callCloseOnSuccess = true;
    var courses;

    $scope.setInitialValues = function() {
        var methods = paymentMethods.get();
        _.findWhere($scope.fields, {name: 'method'}).value = _.findWhere(methods, {id: 'unknown'});
        if (options.course) {
            _.findWhere($scope.fields, {name: 'course_id'}).value = _.findWhere(courses, {id: options.course.id});
        }
    };

    $scope.basket = [];
    $scope.getTotalBasketAmount = function() {
        var total = 0;
        angular.forEach($scope.basket, function(item) {
            total += Number(item.price);
        });
        return total;
    };

    $scope.getTotalAmount = function() {
        if (!$scope.course) {
            return 0;
        }
        return Number($scope.course.product.price) + $scope.getTotalBasketAmount();
    };

    $scope.getGroupTotalAmount = function() {
        return $scope.getTotalAmount() * $scope.getNumberOfNewBookings();
    };

    $scope.getNumberOfNewBookings = function() {
        if (options.customer) { return 1; }
        var bookings = _.findWhere($scope.fields, {name: 'user_id'}).value;
        return bookings ? bookings.length : 0;
    };

    $scope.getProduct = function(product_id) {
        return $rootScope.getPointerById(product_id, $rootScope.trainingcardtypes);
    };
    
    $scope.addProduct = function(product_id) {
        var product = $scope.getProduct(product_id);
        if (product.payWhatYouWant) {
            var modalInstance = $modal.open({templateUrl: 'views/getamountmodal.html'});

            modalInstance.result.then(function (amount) {
                var item = _.findWhere($scope.basket, {product: product});
                if (!item) {
                    item = {product: product, count: 1, payWhatYouWant: true, price: amount};
                    $scope.basket.push(item);
                } else {
                    item.price = amount;
                }
            });
        } else {
            var item = _.findWhere($scope.basket, {product: product});
            if (!item) {
                item = {product: product, count: 1, price: Number(product.price)};
                $scope.basket.push(item);
            } else {
                item.price = Number(item.price) + Number(product.price);
                ++item.count;
            }
        }
    };

    $scope.removeProduct = function(item) {
        if (item.payWhatYouWant) {
            $scope.basket.splice($scope.basket.indexOf(item), 1);
            return;
        }

        --item.count;
        item.price -= Number(item.product.price);
        if (item.count == 0) {
            $scope.basket.splice($scope.basket.indexOf(item), 1);
        }
    };

    function hasPaymentAndAmount() {
        return $scope.getTotalAmount() > 0;
    }

    $scope.bookAndPayVisibility = function() {
        return $rootScope.hasPermission('Checkout handling') && hasPaymentAndAmount();
    };

    function isInvoice() {
        var method = _.findWhere($scope.fields, {name: 'method'});
        return method && method.value && method.value.id == 'invoice';
    }

    var hasMoney = function() {
        var user = _.findWhere($scope.fields, {name: 'user_id'}).value;
        if (user.length == 1) {
            return user[0].getValueCardAmountForSelectedLegalEntity() >= $scope.getTotalAmount();
        }
    };

    var getDate = function() {
        return $scope.course.startTime;
    };

    var getInvoiceDays = function(whenDone) {
        if (!$scope.invoicedays && $rootScope.hasModule('Invoice')) {
            server.get('/api/invoice/settings/get').then(function(result) {
                $scope.invoicedays = result.days;
                whenDone(result.days);
            });
        } else {
            whenDone($scope.invoicedays);
        }
    };

    var getInvoiceSendDate = function() {
        var duedate = _.findWhere($scope.fields, {name: 'duedate'});
        if (duedate.value) {
            var d = _.findWhere($scope.fields, {name: 'duedate'}).value.clone();
            d.addDays(-$scope.invoicedays);
            if (d < Date.today()) {
                d = Date.today();
            }
            return d.yyyymmdd();
        }
    };

    var setDueDate = function() {
        getInvoiceDays(function(days) {
            if (!$scope.course) {
                return;
            }

            var method = _.findWhere($scope.fields, {name: 'method'}).value;
            var newDate = getDate();
            if (method.id == 'directdebit') {
                newDate = util.getBillingDate();
            } else if (method.id == 'invoice') {
                newDate.addDays(days);
            }

            _.findWhere($scope.fields, {name: 'duedate'}).value = newDate;
        });
    };

    var getMethod = function() {
        return _.findWhere($scope.fields, {name: 'method'}).value;
    };

    function isNotBooked(customer) {
        return !_.find(options.course.bookings, function(booking) { return !booking.removed && booking.user_id == customer.id; });
    }

    function showInvoiceFreeText() {
        var payMethod = _.findWhere($scope.fields, {name: 'method'}).value;
        return payMethod && payMethod.id === 'invoice';
    }

    var courseChanged = function() {
        $scope.course = _.findWhere($scope.fields, {name: 'course_id'}).value;
        $scope.fields.forEach(function(f) {
            if (f.name && f.name.startsWith('answers.')) {
                $scope.fields.splice($scope.fields.indexOf(f), 1);
            }
        });
        util.addQuestions($scope.fields, $scope.course.questions);
        setDueDate();
    };

    $scope.fields = [
        {name: 'course_id', title: 'Course', type: 'select', required: true, useId: true, options: function() { return courses; }, change: courseChanged},
        {name: 'user_id', title: 'Customer', type: 'customers', required: true, itemFilter: isNotBooked, useId: true , visible: function() { return !options.customer; }}
    ];

    $scope.fields.push(
        {name: 'method', title: 'Payment method', type: 'paymentmethod', required: true, visible: hasPaymentAndAmount, options: {create: true}, hasMoney: hasMoney },
        {name: 'invoiceExtraInfo', title: 'Invoice comment (max 150 characters)', required: false, visible: showInvoiceFreeText, type: 'textarea', maxlength: 150 },
        {name: 'sendDate', title: 'Invoice date', required: false, type: 'label', visible: function() { return hasPaymentAndAmount() && isInvoice();}, getValue: getInvoiceSendDate },
        {name: 'duedate', title: 'Due date', type: 'date', required: true, visible: hasPaymentAndAmount },
        {hint: 'MULTIPLE_COURSE_BOOKINGS', hintClass: 'alert-info', visible: function() { return $scope.getNumberOfNewBookings() > 1; } }
    );

    $scope.$watch(getMethod, function() {
        setDueDate();
    });

    var addGetSubmitItem = $scope.getSubmitItem;
    $scope.getSubmitItem = function() {
        var item = addGetSubmitItem();
        if(!item.user_id) {
           item.user_id = [options.customer.id];
        }
        item.additional_products = $scope.basket.map(function(item) {
            return {
                id: item.product.id,
                count: item.count,
                price: item.price
            };
        });

        return item;
    };

    $scope.book = function(mode) {
        $scope.loadingStatus.loading = true;
        server.post('/api/course/booking/add', $scope.getSubmitItem(), {addFrom: 'normal', markAsPaid: mode === 'markAsPaid'}, $scope.successTitle, $scope.failedTitle, $scope.itemTitle).then(function(result) {
            $scope.loadingStatus.loading = false;
            if (result.success) {
                var success;
                if (result.data.success.length) {
                    success = $filter('translate')('{0} persons booked').format(result.data.success.length);
                }
                var failed;
                var failedNames;
                if (result.data.failed.length) {
                    failed = $filter('translate')('Failed to add booking for the following {0} persons').format(result.data.failed.length);
                    failedNames = [];
                    result.data.failed.forEach(function(u) {
                        var u = $rootScope.getMember(u);
                        failedNames.push(u ? u.name : $filter('translate')('Anonymous'));
                    });
                }

                var alreadybooked;
                if (result.data.alreadybooked.length) {
                    alreadybooked = $filter('translate')('{0} persons were already booked').format(result.data.alreadybooked.length);
                }
                modalUtils.closeAllModals();
                var groupbookingdoneMdoal = $modal.open({
                    templateUrl: 'views/groupbookingdone.html',
                    controller: 'ModalCtrl',
                    resolve: {
                        options: function() {
                            return {title: 'Booking completed', success: success, failed: failed, failedNames: failedNames, alreadybooked: alreadybooked };
                        }
                    }
                });
                if (mode == 'checkout') {
                    groupbookingdoneMdoal.result.finally(function() {
                        var cashiers = $injector.get('cashiers');
                        var $location = $injector.get('$location');
                        var search = {};
                        if (result.data.bookings.length === 1) {
                            result.data.bookings[0].payments.forEach($rootScope.transformPayment);
                            cashiers.transferPayments(result.data.bookings[0].payments);
                            // Set both legacy in-memory transfer AND query
                            // params so the new StaffNext checkout can hydrate.
                            var bookingPayments = result.data.bookings[0].payments;
                            var ids = bookingPayments.map(function(p) { return p.id; }).filter(Boolean);
                            if (ids.length) search.payment_ids = ids.join(',');
                            var firstPayer = bookingPayments[0] && (bookingPayments[0].payer_id || bookingPayments[0].user_id);
                            if (firstPayer) search.customer_id = firstPayer;
                        }
                        $location.path('/checkout').search(search);
                    });
                }
            }
        });
    };

    $scope.bookAndMarkAsPaid = function() {
        confirm.show('CONFIRM_BOOK_AND_MARK_AS_PAID').then(function() {
            $scope.book('markAsPaid');
        });
    };

    var buttonsDisabled = function() {
        return $scope.addform.$invalid;
    };

    var markAsPaidDisabled = function() {
        var method = _.findWhere($scope.fields, { name: 'method' }).value;
        return buttonsDisabled() || (($scope.getTotalAmount() > 0) && (!method || !method.markAsPaid));
    };

    var checkoutDisabled = function() {
        return buttonsDisabled() || $scope.getNumberOfNewBookings() > 1;
    };

    $scope.bookButtonsConfig = {
        title: 'Book',
        inline: true,
        ladda: function() { return $scope.loadingStatus.loading; },
        actions: [
            { title: 'Book', disabled: buttonsDisabled, onClick: $scope.book },
            { title: 'Book and pay at checkout', disabled: checkoutDisabled, visible: $scope.bookAndPayVisibility, onClick: function() { $scope.book('checkout'); } },
            { title: 'Book and mark as paid', disabled: markAsPaidDisabled, visible: function() { return $rootScope.hasPermission('Checkout handling'); }, onClick: $scope.bookAndMarkAsPaid },
        ]
    };

    if (options.course) {
        courses = [options.course];

        $scope.setInitialValues();
    } else {
        server.get('/api/course/get', {compact: true, bookable: true, fields: 'id,product_id,lastBookingTime,category_id'}).then(function(data) {
            courses = data.filter(function(course) {
                var cat = _.findWhere($rootScope.coursecategories, {id: course.category_id});
                return cat && cat.sites.indexOf($rootScope.selectedSite.id) !== -1;
            });


            courses.forEach(function(c) {
                courseutil.transformCourse(c);
            });

            $scope.setInitialValues();
        });
    }

    // During loading the name of the course is copied from the placeholder
    // By listening to loaded data we make sure the name is updated
    $scope.$on('ApiDataLoaded', function() {
        if (courses) {
            courses.forEach(courseutil.transformCourse)
        }
    });
}]);

courses.controller('CourseBookingChangeCtrl', ['$rootScope', '$scope', '$controller', '$filter', '$modal', 'server', 'util', 'courseutil', 'options', function($rootScope, $scope, $controller, $filter, $modal, server, util, courseutil, options) {
    $controller('ChangeModalCtrl', { $scope: $scope });

    var booking = options.booking;

    if (booking.answers === null) {
        booking.answers = {};
    }

    $scope.fields = [
        {name: 'booker_id', title: 'Booker', required: true, type: 'customer', useId: true }
    ];

    util.addQuestions($scope.fields, options.course.questions);
    $scope.fields.forEach(function(field) {
        var value = booking.answers[field.name];
        if (field.type == 'select') {
            if (value) {
                field.value = _.findWhere(field.options(), {id: value});
            }
        } else if (field.type == 'multiselect') {
            if (value && Array.isArray(value)) {
                field.value = value.map(function(item) {
                    return _.findWhere(field.options(), {id: item});
                });
            }
        } else if (field.type == 'date') {
            field.value = Date.newFull(value);
        } else {
            field.value = value;
        }
    });

    $scope.getLastCancelTime = function() {
        return courseutil.getLastCancelTime(options.course, $scope.booking.cancelRules.lastCancelTime);
    };

    $scope.booking = booking;
    $scope.bookingCancelRules = courseutil.getCancelPolicyListHtml(booking.cancelRules && booking.cancelRules.rules);
    $scope.item = booking;
    $scope.setValues($scope.item);

    Object.keys(booking.variants_for_included_products || {}).forEach(function(product_id, index, array) {
        var variant = array[index];
        var product = _.findWhere($rootScope.trainingcardtypes, {id: Number(product_id)});
        $scope.fields.push({value: variant, type: 'label', title: product.name});
    });

    $scope.postUrl = '/api/course/booking/change';
    $scope.callCloseOnSuccess = true;
    $scope.successTitle = 'Saved changes';
    $scope.failedTitle = 'Failed to save changes';
    angular.forEach(booking.additional_products, function(p) {
        p.product = $rootScope.getPointerById(p.id, $rootScope.trainingcardtypes);
    });
    $scope.basket = booking.additional_products;
    $scope.getTotalAmount = function() {
        return Number(options.course.product.price) + $scope.getTotalBasketAmount();
    };
    $scope.titleSuffix = function() {
        return $filter('translate')('booking') + ' ' + $filter('translate')('for') + ' ' + booking.user.name;
    };

    $scope.getTotalBasketAmount = function() {
        var total = 0;
        angular.forEach($scope.basket, function(item) {
            total += Number(item.price);
        });
        return total;
    };
}]);
